import Pino from 'pino';
export function createPinoLogger() {
    const ENV = process.env.NODE_ENV || 'development';
    const LOG_LEVELS = ['trace', 'debug', 'info', 'warn', 'error', 'fatal'];
    const LOG_LEVEL_MAP = {
        production: 'info',
        development: 'debug',
        test: 'error',
        default: 'trace',
    };
    const LEVEL_DEFAULT = LOG_LEVEL_MAP[ENV] || LOG_LEVEL_MAP.default;
    let level = process.env.LOG_LEVEL?.toLowerCase();
    if (!level || !LOG_LEVELS.includes(level)) {
        level = LEVEL_DEFAULT;
    }
    console.log(`Log level for ${ENV} set to ${level}`);
    return Pino({
        messageKey: 'message',
        level,
        ...(ENV === 'development' && {
            transport: {
                target: 'pino-pretty',
            },
        }),
    });
}
//# sourceMappingURL=pinoLogger.js.map